<template>
  <div class="mall-order-card">
    <MallSubTitle :label="'카드 간편결제'" />
    <MallCard>
      <div v-if="card" class="mall-order-card__row">
        <div class="mall-order-card__info">
          <div class="mall-order-card__logo">
            <img
              v-if="card.logo"
              :class="{ 'mall-order-card__logo-img--badge': card.isBadgeLogo }"
              :src="card.logo"
              :alt="card.companyName"
            />
          </div>
          <div class="mall-order-card__text">
            <span class="mall-order-card__company">{{ card.companyName }}</span>
            <span class="mall-order-card__number">{{ card.number }}</span>
          </div>
        </div>
        <MallButton :label="'변경'" :type="'soft'" :size="'sm'" @click="$emit('change-click')" />
      </div>
      <div v-else class="mall-order-card__row">
        <span class="mall-order-card__empty">등록된 카드가 없어요.</span>
        <MallButton :label="'등록'" :type="'soft'" :size="'sm'" @click="$emit('change-click')" />
      </div>
    </MallCard>
  </div>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallCard from '@/components/new/atoms/MallCard.vue'
import MallSubTitle from '@/components/new/atoms/MallSubTitle.vue'

export default {
  name: 'MallOrderCard',
  components: {
    MallButton,
    MallCard,
    MallSubTitle,
  },
  props: {
    // { companyName, number(마스킹된 카드번호), logo(없으면 미노출), isBadgeLogo(서버 카드사 로고) }, 등록된 카드가 없으면 null
    card: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.mall-order-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mall-order-card__row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mall-order-card__info {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.mall-order-card__logo {
  display: flex;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #FFF;
  overflow: hidden;
}

.mall-order-card__logo img {
  display: block;
  width: 46px;
  height: 32px;
  object-fit: cover;
}

/* 서버 카드사 로고는 60px 원형 배지 이미지라 영역에 맞춰 그대로 노출 */
.mall-order-card__logo .mall-order-card__logo-img--badge {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.mall-order-card__text {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-order-card__company {
  color: var(--color-text-main);
}

.mall-order-card__empty {
  flex: 1;
  color: #8B95A1;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-order-card__number {
  color: #8B95A1;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderCard.vue